import { createAction } from '@reduxjs/toolkit';
import { createActionWithCallback } from 'core/store/utils';
import { RequestError, ProductCode } from 'types';

export const createProductCode = createActionWithCallback<void, Error>()(
  'product-code/create-product-code',
  (productCode: ProductCode) => ({
    payload: productCode,
  })
);

export const createdProductCode = createAction(
  'product-code/created-product-code',
  (data?: ProductCode, error?: RequestError) => ({
    payload: error || data,
    error: Boolean(error),
  })
);

export const deleteProductCode = createAction('product-code/delete-product-code', (id: string) => ({
  payload: undefined,
  meta: { id },
}));

export const deletedProductCode = createAction(
  'product-code/deleted-product-code',
  (data?: boolean, error?: RequestError | Response) => ({
    payload: error || data,
    error: Boolean(error),
  })
);

export default {
  createProductCode,
  createdProductCode,
  deleteProductCode,
  deletedProductCode,
};
